module.exports = __webpack_public_path__ + "img/5.6a4e33d2.png";